export const GET_ROKT_CONFIG_REQUESTED = 'brand/GET_ROKT_CONFIG_REQUESTED';
export const GET_ROKT_CONFIG_SUCCESS = 'brand/GET_ROKT_CONFIG_SUCCESS';
export const GET_ROKT_CONFIG_FAILURE = 'brand/GET_ROKT_CONFIG_FAILURE';

export const UPDATE_ROKT_CONFIG_REQUESTED = 'brand/UPDATE_ROKT_CONFIG_REQUESTED';
export const UPDATE_ROKT_CONFIG_SUCCESS = 'brand/UPDATE_ROKT_CONFIG_SUCCESS';
export const UPDATE_ROKT_CONFIG_FAILURE = 'brand/UPDATE_ROKT_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  roktList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_ROKT_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        roktList: [],
      };
    }
    case GET_ROKT_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        roktList: action.result,
      };
    }
    case GET_ROKT_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        roktList: [],
      };
    }
    case UPDATE_ROKT_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_ROKT_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_ROKT_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getRoktConfig = (brandId) => {
  return {
    types: [GET_ROKT_CONFIG_REQUESTED, GET_ROKT_CONFIG_SUCCESS, GET_ROKT_CONFIG_FAILURE],
    promise: client => client.get(`getRoktConfig/${brandId}`)
  };
};

export const updateRoktConfig = (brandId, data) => {
  return {
    types: [UPDATE_ROKT_CONFIG_REQUESTED, UPDATE_ROKT_CONFIG_SUCCESS, UPDATE_ROKT_CONFIG_FAILURE],
    promise: client => client.post(`updateRoktConfig/${brandId}`, { data })
  };
};
